import { ShipperInformation } from 'core/ui/components/shipper/ShipperInformation'

import { type ProposalStep, type Proposal } from '../domain/Proposal'
import { getRateType } from '../domain/RateType'
import {
  formatContractDate,
  formatDeadline,
  formatRateType,
  getDeadlineColorTokenIndicator,
} from '../presenters/rfpPresenter'
import {
  DeadlineIndicator,
  DeadlineWrapper,
  Info,
  InfoWrapper,
  ShipperInfoWrapper,
  SingleInfoWrapper,
  Subtitle,
} from './RfpInformation.styles'

export type RfpInformationProps = {
  disabled: boolean
  proposal: Proposal
  step?: ProposalStep
  RfpRatesButton?: JSX.Element
}

export function RfpInformation({
  disabled,
  proposal,
  step = 'bid',
  RfpRatesButton,
}: RfpInformationProps): JSX.Element {
  const { rateType, rfp } = proposal

  const { capacityTimePeriod, contractEnd, contractStart } = rfp
  const contractDate = formatContractDate(contractStart, contractEnd)
  const contractDeadline = formatDeadline(proposal, step)
  const deadlineColorToken = getDeadlineColorTokenIndicator(proposal, disabled, step)

  return (
    <>
      <InfoWrapper>
        <SingleInfoWrapper>
          <Subtitle>contract</Subtitle>
          <Info>{contractDate}</Info>
        </SingleInfoWrapper>
        <SingleInfoWrapper>
          <Subtitle>volume frequency</Subtitle>
          <Info>{capacityTimePeriod}</Info>
        </SingleInfoWrapper>
        <SingleInfoWrapper>
          <Subtitle>rates</Subtitle>
          <Info>{formatRateType(getRateType(rateType))}</Info>
        </SingleInfoWrapper>
        <SingleInfoWrapper>
          <Subtitle>deadline</Subtitle>
          <DeadlineWrapper>
            <Info>{contractDeadline}</Info>
            <DeadlineIndicator $colorToken={deadlineColorToken} />
          </DeadlineWrapper>
        </SingleInfoWrapper>
        {RfpRatesButton !== undefined && RfpRatesButton}
      </InfoWrapper>
      <ShipperInfoWrapper>
        <ShipperInformation
          companyName={proposal.shipperCompanyName}
          contactName={rfp.shipperName}
          email={rfp.shipperEmail}
          phone={rfp.shipperPhone}
          logo={rfp.shipperLogo}
          showContactInfo
        />
      </ShipperInfoWrapper>
    </>
  )
}
